import {convertPrereleaseConfiguration} from './schema-v1.js';

export const MAX_DISCLAIMER_HANDLES = 15;
export const isMetaobjectHandle = (value) => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value) && value.length <= 255;

export function validateMetaobjectHandles(configuration) {
  const errors = [];
  if (configuration.productGroupHandle !== undefined && configuration.productGroupHandle !== '' && !isMetaobjectHandle(configuration.productGroupHandle)) errors.push('Choose a valid product group.');
  const handles = configuration.disclaimerHandles;
  if (handles !== undefined && (!Array.isArray(handles) || handles.length > MAX_DISCLAIMER_HANDLES || handles.some((handle) => !isMetaobjectHandle(handle)) || new Set(handles).size !== handles.length)) errors.push(`Choose up to ${MAX_DISCLAIMER_HANDLES} unique disclaimers.`);
  if (configuration.productSwitcherDraft != null && (configuration.productSwitcherDraft.schemaVersion !== 1 || configuration.productSwitcherDraft.baseHandle !== configuration.productGroupHandle || !configuration.productSwitcherDraft.value || !Array.isArray(configuration.productSwitcherDraft.value.products))) errors.push('The switcher draft must belong to the selected group.');
  return errors;
}

// Read-only conversion. Empty handles/lists are intentional and never fall back.
export async function migrateHandleSettings(value, {group, productSwitcherDraft, resolveDisclaimers}) {
  if (!value) return null;
  const next = convertPrereleaseConfiguration(value);
  if (!Object.hasOwn(next, 'productGroupHandle')) {
    next.productGroupHandle = group?.handle || '';
    if (productSwitcherDraft?.baseId === group?.id && group) next.productSwitcherDraft = {...productSwitcherDraft, baseHandle: group.handle};
  }
  if (!Object.hasOwn(next, 'disclaimerHandles')) {
    const ids = next.noticeIds || [];
    const notices = ids.length ? await resolveDisclaimers(ids) : [];
    next.disclaimerHandles = ids.map((id) => {
      const notice = notices.find((item) => item.id === id);
      if (!notice?.handle) throw new Error(`Cannot migrate missing disclaimer ${id}. Restore it or repair the selection first.`);
      return notice.handle;
    });
  }
  delete next.noticeIds;
  const errors = validateMetaobjectHandles(next);
  if (errors.length) throw new Error(errors.join('\n'));
  return next;
}
